import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import Layout from './components/Layout'
import RequireAuth from './components/RequireAuth'
import RequireProtect from './components/RequireProtect'
import ProtectedRoute from './components/ProtectedRoute'
import PageTransition from './components/PageTransition'
import OverviewPage from './pages/OverviewPage'
import SchedulePage from './pages/SchedulePage'
import ShowsPage from './pages/ShowsPage'
import MusicPage from './pages/MusicPage'
import CommercePage from './pages/CommercePage'
import FinancePage from './pages/FinancePage'
import TourManagerPage from './pages/TourManagerPage'
import TasksPage from './pages/TasksPage'
import ChatPage from './pages/ChatPage'
import TeamManagementPage from './pages/TeamManagementPage'
import TeamMemberEditPage from './pages/TeamMemberEditPage'
import TeamHubPage from './pages/TeamHubPage'
import SettingsPage from './pages/SettingsPage'
import LoginPage from './pages/LoginPage'
import LoginOtpPage from './pages/LoginOtpPage'
import SignupPage from './pages/signup/SignupPage'
import ProtectPage from './pages/ProtectPage'
import GoogleCalendarCallbackPage from './pages/GoogleCalendarCallbackPage'
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage'
import TermsOfServicePage from './pages/legal/TermsOfServicePage'
import AccessibilityStatementPage from './pages/legal/AccessibilityStatementPage'
import DeckPage from './pages/DeckPage'
import MasterPlanPage from './pages/MasterPlanPage'

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Legal Pages */}
          <Route
            path="/privacy-policy"
            element={
              <PageTransition>
                <PrivacyPolicyPage />
              </PageTransition>
            }
          />
          <Route
            path="/terms-of-service"
            element={
              <PageTransition>
                <TermsOfServicePage />
              </PageTransition>
            }
          />
          <Route
            path="/accessibility-statement"
            element={
              <PageTransition>
                <AccessibilityStatementPage />
              </PageTransition>
            }
          />
          
          {/* Deck Page (password-protected internally, no PageTransition — deck uses fixed positioning) */}
          <Route path="/deck" element={<DeckPage />} />

          {/* Master Plan (password-protected, internal execution document) */}
          <Route path="/masterplan" element={<MasterPlanPage />} />

          {/* Auth Pages */}
          <Route
            path="/protect"
            element={
              <PageTransition>
                <ProtectPage />
              </PageTransition>
            }
          />
          <Route
            path="/login"
            element={
              <RequireProtect>
                <PageTransition>
                  <LoginPage />
                </PageTransition>
              </RequireProtect>
            }
          />
          <Route
            path="/login-otp"
            element={
              <RequireProtect>
                <PageTransition>
                  <LoginOtpPage />
                </PageTransition>
              </RequireProtect>
            }
          />
          <Route
            path="/signup"
            element={
              <RequireProtect>
                <PageTransition>
                  <SignupPage />
                </PageTransition>
              </RequireProtect>
            }
          />
          <Route
            path="/"
            element={
              <RequireProtect>
                <RequireAuth>
                  <Layout />
                </RequireAuth>
              </RequireProtect>
            }
          >
            <Route index element={<Navigate to="/overview" replace />} />
            <Route path="overview" element={<ProtectedRoute requiredPermission="overview"><OverviewPage /></ProtectedRoute>} />
            <Route path="schedule" element={<ProtectedRoute requiredPermission="schedule"><SchedulePage /></ProtectedRoute>} />
            <Route path="shows" element={<ProtectedRoute requiredPermission="shows"><ShowsPage /></ProtectedRoute>} />
            <Route path="music" element={<ProtectedRoute requiredPermission="music"><MusicPage /></ProtectedRoute>} />
            <Route path="commerce" element={<CommercePage />} />
            <Route path="finance" element={<ProtectedRoute requiredPermission="finance"><FinancePage /></ProtectedRoute>} />
            <Route path="tour-manager" element={<TourManagerPage />} />
            <Route path="tasks" element={<ProtectedRoute requiredPermission="tasks"><TasksPage /></ProtectedRoute>} />
            <Route path="chat" element={<ProtectedRoute requiredPermission="chat"><ChatPage /></ProtectedRoute>} />
            <Route path="team" element={<ProtectedRoute requiredPermission="team"><TeamManagementPage /></ProtectedRoute>} />
            <Route path="team/:teamMemberId/edit" element={<TeamMemberEditPage />} />
            <Route path="team-hub" element={<TeamHubPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="google-calendar-callback" element={<GoogleCalendarCallbackPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
